// extracted by mini-css-extract-plugin
export default {"feedback_container":"Feedback_feedback_container__uALSZ","feedback_label":"Feedback_feedback_label__d14oy","feedback_icon":"Feedback_feedback_icon__uupfa"};